export enum ClauseGroupType {
  STANDARD_FORMAT_REQUIREMENT = 'STANDARD_FORMAT_REQUIREMENT',
  NATIONAL_DETERMINED_REQUIREMENT = 'NATIONAL_DETERMINED_REQUIREMENT',
}
